/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useQuery } from '@tanstack/react-query';

import { getRecommendationResults } from './recommendation-api';
import { getNextWeekend } from '../utils/getNextWeekend';

export const CAMPSITES_RARE_FINDS_KEY = 'campsites-rare-finds';

export function useHiddenGems({
    isEnabled,
    latitude,
    longitude,
}: {
    isEnabled: boolean;
    latitude?: number;
    longitude?: number;
}) {
    const [startDate, endDate] = getNextWeekend(); // Date objects in UTC time

    const searchParams = new URLSearchParams({
        m: 'rare-finds',
        start_date: startDate.toISOString(), // 2025-05-09T00:00:00.000Z
        end_date: endDate.toISOString(), // 2025-05-11T00:00:00.000Z
    });

    if (latitude && longitude) {
        searchParams.append('lat', latitude.toString());
        searchParams.append('lng', longitude.toString());
    }

    return useQuery({
        queryKey: [CAMPSITES_RARE_FINDS_KEY, searchParams.toString()],
        queryFn: async ({ signal }) => getRecommendationResults(searchParams, signal),
        staleTime: Infinity, // not expected to change often
        refetchOnWindowFocus: false,
        retry: 3,
        enabled: isEnabled,
    });
}
